import { call, put, takeEvery, select } from 'redux-saga/effects';
import { fetchCategories } from '@kineticdata/react';

import { actions, types } from '../modules/categories';
import { actions as systemErrorActions } from '../modules/systemError';

export function* fetchCategoriesSaga() {
  try {
    const kappSlug = yield select(state => state.app.config.kappSlug);

    const { categories, errors, serverError } = yield call(fetchCategories, {
      kappSlug,
      include: 'categorizations,attributes',
    });

    if (serverError) {
      yield put(systemErrorActions.setSystemError(serverError));
    } else if (errors) {
      yield put(actions.setCategoriesErrors(errors));
    } else {
      yield put(actions.setCategories(categories));
    }
  } catch (error) {
    console.log('Error in fetchCategoriesSaga: ' + util.inspect(error));
  }
}

export function* watchCategories() {
  yield takeEvery(types.FETCH_CATEGORIES, fetchCategoriesSaga);
}
